import UseContext from 'hooks/useContext';
import {
  isMissionPerimeterFieldShown,
  missionPerimeterText,
} from 'components/perimeter/missionPerimeter';

const NONE_VALUE = '';

/** The perimeter a new mission belongs to. Nothing is shown for a company
 *  without active perimeters: the mission is then visible to every manager,
 *  as before perimeters existed. */
const MissionPerimeterField = ({ field }) => {
  const { language } = UseContext();
  const text = (key) => missionPerimeterText(language, key);

  if (field.status === 'loading') {
    return <span className="ft-sm text-gray-500">{text('loading')}</span>;
  }

  if (field.status === 'error') {
    return (
      <div className="flex items-center gap-2 ft-sm text-red-500">
        <span>{text('loadError')}</span>
        <button
          type="button"
          className="underline text-gray-700"
          onClick={field.reload}
        >
          {text('retry')}
        </button>
      </div>
    );
  }

  if (!isMissionPerimeterFieldShown(field)) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col">
        <span className="ft-xl font-medium text-gray-900">{text('title')}</span>
        <span className="ft-sm text-gray-500">{text('description')}</span>
      </div>
      <select
        aria-label={text('label')}
        className="w-full h-10 px-3 ft-b border rounded-lg text-sm bg-white"
        value={field.perimeterId ?? NONE_VALUE}
        onChange={(event) => field.setPerimeterId(event.target.value || null)}
      >
        <option value={NONE_VALUE}>{text('none')}</option>
        {field.perimeters.map((perimeter) => (
          <option key={perimeter.id} value={perimeter.id}>
            {perimeter.name}
          </option>
        ))}
      </select>
      {field.perimeterId ? null : (
        <span className="ft-sm text-gray-500">{text('noneHint')}</span>
      )}
    </div>
  );
};

export default MissionPerimeterField;
